import { TableContext } from "@/components/TableWithSelect/TableContext";

import React, { useContext, useMemo } from "react";

import { Cell, Row } from "@tanstack/react-table";
import { twMerge } from "tailwind-merge";

import { TableCell } from "./TableCell";

type TableRowProps = {
  rowKey: number;
  row: Row<any>;
};

export const TableRow: React.FC<TableRowProps> = ({ rowKey, row }) => {
  const { selectedIds, onRowClick } = useContext(TableContext);

  const isSelected = useMemo(
    () => selectedIds.includes(row.original.id),
    [row, selectedIds],
  );

  return (
    <tr
      key={rowKey}
      className={twMerge(
        `group border-grey2 hover:bg-hover-color h-[48px] cursor-pointer border-b bg-white text-sm last:border-b-0`,
      )}
      onClick={() => onRowClick(row)}
    >
      {row.getVisibleCells().map((cell: Cell<any, any>, i) => (
        <TableCell
          cell={cell}
          key={`${cell.id}_${i}`}
          isSelected={isSelected}
        />
      ))}
    </tr>
  );
};
